import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { create } from 'kts-scaffold-framework/utils/form';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import {
    Button,
    Tree,
    Icon,
    message,
    Modal
} from 'antd';
import { transformDuplicate } from 'kts-platform-frame/entry/constant/InvoiceType/EnumInvoiceType';

const css = require('./index.scss');
const TreeNode = Tree.TreeNode;

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentWillMount() {
        ModulesAction.departmentQuery();
        ModulesAction.getCompanyInfo();
    }
    
    render() {
        const companyInfo = this.modulesState.companyInfo;
        return (
            <div className={css['sidebar']}>
                <div className={css['sidebar-header']}>
                    <h1>部门管理</h1>
                    <Button
                        type="primary"
                        icon="plus"
                        onClick={this.newCreate}
                    >新建
                    </Button>
                </div>
                <div className={css['sidebar-handler']}>
                    <Tree
                        showIcon={true}
                        defaultExpandAll={true}
                    >
                        {this.renderTreeNodes(this.modulesState.treeDate)}
                    </Tree>
                </div>
                <Modal
                    title="删除部门"
                    visible={this.modulesState.deleteVisible}
                    onOk={this.deleteDepartmentOk}
                    onCancel={this.deleteDepartmentCancel}
                    className='kts-app-ant-modal'
                >
                    <p style={{display: 'flex', alignItems: 'center'}}><Icon type="zhuyi" style={{color: '#ffb301', fontSize: '24px', marginRight: '12px'}}/>确定要删除{this.modulesState.deleteName}？删除将不可撤销!</p>
                </Modal>
            </div>
        );
    }

    private newCreate = () => {
        ModulesAction.updateView(false, false);
        ModulesAction.updateRefreshEdit(true);
        ModulesAction.updateNoteWord('');
    }

    private renderTreeNodes = (data) => {
        return data && data.map((item) => {
            if (item.children.length > 0) {
                return (
                    <TreeNode icon={<Icon type="wendang" />} title={this.renderTitle(item.number, item.name, item.departmentId)} key={item.departmentId} id={item.departmentId}>
                        {this.renderTreeNodes(item.children.sort((a, b) => { return a.number.toLocaleLowerCase() > b.number.toLocaleLowerCase();}))}
                    </TreeNode>
                );
            }
            return <TreeNode icon={<Icon type="wendang" />} title={this.renderTitle(item.number, item.name, item.departmentId, true)} key={item.departmentId} id={item.departmentId} />;
        });
    }

    private renderTitle = (nu, na, id, yesOr?: boolean) => {
        return (
            <div className={css['sidebar-treenode']}>
                <div className={css['sidebar-treenode-outer']}>
                    <span className={css['sidebar-treenode-text']} title={`(${nu})${na}`}>{`(${nu})${na}`}</span>
                    <div className={css['sidebar-treenode-hander']}>
                        {
                            nu === '001' ? (
                                <Icon onClick={() => this.addDepartment(id)} type="plus"/>
                            ) : (
                                <div>
                                    <Icon onClick={() => this.editdepartment(id)} type="bianji"/>
                                    <Icon onClick={() => this.addDepartment(id)} type="plus"/>
                                    <Icon onClick={() => this.deleteDepartment(id, na, yesOr)} type="delete"/>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }

    private editdepartment = (id) => {
        ModulesAction.updateView(false, true);
        ModulesAction.updateRefreshEdit(true);
        ModulesAction.departmentInfo({departmentId: id});
        ModulesAction.getParentAvailable(id);
    }

    private addDepartment = (id) => {
        ModulesAction.updateView(false, false, id);
    }

    private deleteDepartment = (id, na, yesOr) => {
        if(yesOr) {
            ModulesAction.updateDeleteVisable(true);
            ModulesAction.updateDeleteId(id);
            ModulesAction.updateDeleteName(na);
        } else {
            message.warning('这不是一个空的部门');
        }
    }

    private deleteDepartmentOk = () => {
        ModulesAction.deleteDepartment({departmentId: this.modulesState.deleteId})
        .then(res => {
            if(!res.er) {
                this.deleteDepartmentCancel();
            }
        });
    }

    private updateDeleteVisable = (b) => {
        ModulesAction.updateDeleteVisable(b);
    }

    private deleteDepartmentCancel = () => {
        this.updateDeleteVisable(false);
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Organization/UI.Sidebar.tsx